export enum ExecutionType {
  Create = 'Create',
  Update = 'Update',
  Delete = 'Delete',
  Approve = 'Approve',
  Merge = 'Merge',
}
